import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { leelaApi } from 'src/store/leela-api';
import { benderApi } from 'src/store/bender-api';
import { spotlightApi } from 'src/store/spotlight-api';

export const store = configureStore({
  reducer: {
    [leelaApi.reducerPath]: leelaApi.reducer,
    [benderApi.reducerPath]: benderApi.reducer,
    [spotlightApi.reducerPath]: spotlightApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(leelaApi.middleware, benderApi.middleware, spotlightApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
